export const STATUS = {
  STORAGE: 9,
  USAGE: 10,
  REPAIR: 11,
  ARCHIVE: 12,
};

export const ACTION_TYPE = {
  ISSUANCE: 1,
  STORAGE: 2,
  REPAIR: 3,
  WRITE_OFF: 4,
  SERVICE: 5,
  USAGE_CHANGE: 6,
  STORAGE_CHANGE: 7,
  REPAIR_CHANGE: 8
};

export const STATUS_NAME = {
  STORAGE: 'storage',
  USAGE: 'usage',
  REPAIR: 'repair',
};
